<template>
  <div class="crud_form_wrapper">
    <!-- Start:: Title -->
    <div class="form_title_wrapper">
      <h4>{{ $t("PLACEHOLDERS.add_ads") }}</h4>
    </div>
    <div class="col-12 text-end">
      <v-btn @click="$router.go(-1)" style="color: #008274">
        <i class="fas fa-backward"></i>
      </v-btn>
    </div>
    <!-- End:: Title -->

    <!-- Start:: Single Step Form Content -->
    <div class="single_step_form_content_wrapper">
      <ValidationObserver ref="observer" v-slot="{ invalid }">
        <form @submit.prevent="validateFormInputs">
          <div class="row">
            <!-- Start:: Image Upload Input -->

            <base-image-upload-input
              col="6"
              identifier="image"
              :placeholder="$t('PLACEHOLDERS.mobile_image')"
              :field="$t('PLACEHOLDERS.mobile_image')"
              @selectImage="selectImage"
              :acceptVideo="true"
              required
            />
            <base-image-upload-input
              col="6"
              identifier="website_image"
              :placeholder="$t('PLACEHOLDERS.website_image')"
              :field="$t('PLACEHOLDERS.website_image')"
              @selectImage="selectWebsiteImage"
              :acceptVideo="true"
              required
            />
            <!-- End:: Image Upload Input -->

            <!-- Start:: Name AR -->
            <ValidationProvider
              :name="$t('PLACEHOLDERS.nameAr')"
              rules="required|arabicLettersAndNumbersOnly"
              v-slot="{ errors }"
              class="col-lg-6"
            >
              <base-input
                col="12"
                type="text"
                :placeholder="$t('PLACEHOLDERS.nameAr')"
                v-model.trim="data.nameAr"
                @input="data.nameAr = allowArabicNumbersSymbols($event)"
                :errors="errors[0]"
                required
              />
            </ValidationProvider>

            <!-- Start:: Name EN -->
            <ValidationProvider
              :name="$t('PLACEHOLDERS.nameEn')"
              rules="required|englishLettersAndNumbersOnly"
              v-slot="{ errors }"
              class="col-lg-6"
            >
              <base-input
                col="12"
                type="text"
                :placeholder="$t('PLACEHOLDERS.nameEn')"
                v-model.trim="data.nameEn"
                @input="data.name_en = allowEnglishNumbersSymbols($event)"
                :errors="errors[0]"
                required
              />
            </ValidationProvider>

            <!-- Start:: Desc AR -->
            <ValidationProvider
              :name="$t('PLACEHOLDERS.descAr')"
              rules="required|arabicLettersAndNumbersOnly"
              v-slot="{ errors }"
              class="col-lg-6"
            >
              <base-input
                col="12"
                type="textarea"
                :placeholder="$t('PLACEHOLDERS.descAr')"
                v-model.trim="data.descAr"
                :errors="errors[0]"
                required
              />
            </ValidationProvider>

            <!-- Start:: Desc EN -->
            <ValidationProvider
              :name="$t('PLACEHOLDERS.descEn')"
              rules="required|englishLettersAndNumbersOnly"
              v-slot="{ errors }"
              class="col-lg-6"
            >
              <base-input
                col="12"
                type="textarea"
                :placeholder="$t('PLACEHOLDERS.descEn')"
                v-model.trim="data.descEn"
                :errors="errors[0]"
                required
              />
            </ValidationProvider>

            <!-- Start:: Start Date -->
            <ValidationProvider
              :name="$t('PLACEHOLDERS.start_date')"
              rules="required"
              v-slot="{ errors }"
              class="col-lg-6"
            >
              <base-picker-input
                col="12"
                type="date"
                :disabledDate="disabledDate"
                :placeholder="$t('PLACEHOLDERS.start_date')"
                v-model.trim="data.publish_start_date"
                :errors="errors[0]"
                required
              />
            </ValidationProvider>

            <!-- Start:: End Date -->
            <!-- Start:: End Date -->
            <ValidationProvider
              :name="$t('PLACEHOLDERS.end_date')"
              :rules="`required|date_after:${data.publish_start_date}`"
              v-slot="{ errors }"
              class="col-lg-6"
            >
              <base-picker-input
                col="12"
                type="date"
                :disabledDate="disabledDate"
                :placeholder="$t('PLACEHOLDERS.end_date')"
                v-model.trim="data.publish_end_date"
                :errors="errors[0]"
                required
              />
            </ValidationProvider>

            <!-- Start:: Switch -->
            <div class="input_wrapper switch_wrapper my-5 col-lg-12">
              <v-switch
                color="green"
                :label="
                  data.active
                    ? $t('PLACEHOLDERS.active')
                    : $t('PLACEHOLDERS.notActive')
                "
                v-model="data.active"
                hide-details
              ></v-switch>
            </div>

            <!-- Start:: Submit Button -->
            <div class="btn_wrapper col-12 text-end">
              <base-button
                class="mt-2"
                styleType="primary_btn"
                :btnText="$t('BUTTONS.save')"
                :isLoading="isWaitingRequest"
                :disabled="invalid || isWaitingRequest"
              />
            </div>
          </div>
        </form>
      </ValidationObserver>
    </div>
    <!-- END:: Single Step Form Content -->
  </div>
</template>

<script>
import BaseImageUploadInput from "../../../components/formInputs/BaseImageUploadInput.vue";
import moment from "moment";
import allowLanguageMinxin from "@/mixins/allowLanguageMinxins.js";

export default {
  name: "CreateAds",
  mixins: [allowLanguageMinxin],

  components: { BaseImageUploadInput },

  data() {
    return {
      // Start:: Loader Control Data
      isWaitingRequest: false,
      // End:: Loader Control Data

      file: null,
      fileType: "",

      // Start:: Data Collection To Send
      data: {
        image: {
          path: null,
          file: null,
        },
        website_image: {
          path: null,
          file: null,
        },
        nameAr: null,
        nameEn: null,
        descAr: null,
        descEn: null,
        active: true,
        publish_start_date: null,
        publish_end_date: null,
      },
      // End:: Data Collection To Send

      arabicRegex: /^[\u0600-\u06FF\s]+$/,
      EnRegex: /[\u0600-\u06FF]/,
    };
  },

  computed: {},

  methods: {
    selectImage(selectedImage) {
      this.data.image = selectedImage;
    },

    selectWebsiteImage(selectedImage) {
      this.data.website_image = selectedImage;
    },

    disabledDate(current) {
      return current && current < moment().startOf("day");
    },

    onCopy(event) {
      event.preventDefault();
    },
    onPaste(event) {
      event.preventDefault();
    },

    validateInput() {
      // Remove non-Arabic characters from the input
      this.data.nameAr = this.data.nameAr.replace(/[^\u0600-\u06FF\s]/g, "");
    },
    removeArabicCharacters() {
      this.data.nameEn = this.data.nameEn.replace(this.EnRegex, "");
    },

    handleFileSelected({ file, fileType }) {
      this.file = file; // Store the selected file in your data
      this.fileType = fileType; // Store the selected file in your data
    },
    handleFileRemoved() {
      this.file = null; // Reset the file when it's removed
      this.fileType = "";
    },

    // Start:: validate Form Inputs
    validateFormInputs() {
      this.isWaitingRequest = true;

      if (!this.data.nameAr) {
        this.isWaitingRequest = false;
        this.$message.error(this.$t("VALIDATION.nameAr"));
        return;
      } else if (!this.data.nameEn) {
        this.isWaitingRequest = false;
        this.$message.error(this.$t("VALIDATION.nameEn"));
        return;
      } else if (!this.data.descAr) {
        this.isWaitingRequest = false;
        this.$message.error(this.$t("VALIDATION.descAr"));
        return;
      } else if (!this.data.descEn) {
        this.isWaitingRequest = false;
        this.$message.error(this.$t("VALIDATION.descEn"));
        return;
      } else if (!this.data.image.file && !this.data.image.type) {
        this.isWaitingRequest = false;
        this.$message.error(this.$t("VALIDATION.media"));
        return;
      } else if (!this.data.website_image.file && !this.data.website_image.type) {
        this.isWaitingRequest = false;
        this.$message.error(this.$t("PLACEHOLDERS.website_image"));
        return;
      } else if (!this.data.publish_start_date) {
        this.isWaitingRequest = false;
        this.$message.error(this.$t("VALIDATION.publish_start_date"));
        return;
      } else if (!this.data.publish_end_date) {
        this.isWaitingRequest = false;
        this.$message.error(this.$t("VALIDATION.publish_end_date"));
        return;
      } else {
        this.submitForm();
        return;
      }
    },
    // End:: validate Form Inputs

    // Start:: Submit Form
    async submitForm() {
      const REQUEST_DATA = new FormData();
      // Start:: Append Request Data
      if (this.data.nameAr) {
        REQUEST_DATA.append("name[ar]", this.data.nameAr);
      }
      if (this.data.nameEn) {
        REQUEST_DATA.append("name[en]", this.data.nameEn);
      }
      if (this.data.descAr) {
        REQUEST_DATA.append("description[ar]", this.data.descAr);
      }
      if (this.data.descEn) {
        REQUEST_DATA.append("description[en]", this.data.descEn);
      }

      if (this.data.image.file) {
        REQUEST_DATA.append("image", this.data.image.file);
        REQUEST_DATA.append("media", this.data.image.file);
        REQUEST_DATA.append(
          "type",
          this.data.image?.type == "image_file" ? "image" : "video"
        );
      }

      if (this.data.website_image.file) {
        REQUEST_DATA.append("website_image", this.data.website_image.file);
      }

      if (this.data.publish_start_date) {
        REQUEST_DATA.append("start", this.data.publish_start_date);
      }
      if (this.data.publish_end_date) {
        REQUEST_DATA.append("end", this.data.publish_end_date);
      }
      REQUEST_DATA.append("is_active", this.data.active ? 1 : 0);
      // Start:: Append Request Data

      try {
        await this.$axios({
          method: "POST",
          url: `sliders`,
          data: REQUEST_DATA,
        });
        this.isWaitingRequest = false;
        this.$message.success(this.$t("MESSAGES.addedSuccessfully"));
        this.$router.push({ path: "/ads/all" });
      } catch (error) {
        this.isWaitingRequest = false;
        this.$message.error(error.response.data.message);
      }
    },
    // End:: Submit Form
  },

  created() {
    // Start:: Fire Methods
    // End:: Fire Methods
  },
};
</script>
